import Constants from '../Shared/Constants';

const Log = {
  message: (messages) => {
    Constants.Debug && console.log(messages);
  },
};

export default Log;
